import { useParams } from 'react-router';
import { useAppDispatch } from '../../redux/store';
import { ErrorState } from '../../redux/AppReducer';
import { AppActions } from '../../redux/AppActions';
import { useState, useEffect } from 'react';
import { AVAILABLE_VIDEOS, IPropsVideo } from '../../common/videos';
import { serverError } from '../../common/constants';
import './VideoPage.scss';
import { VideoVimeoComponent } from '../../components/UI/VideoVimeoComponent/VideoVimeoComponent';
const VideoPage = () => {
	const dispatch = useAppDispatch();
	const { videoId } = useParams();
	const [selectedVideo, setSelectedVideo] = useState<IPropsVideo | undefined>(undefined);
	const handleError = (error: ErrorState) => dispatch(AppActions.setGeneralError(error));
	useEffect(() => {
		if (videoId !== undefined) {
			let video = AVAILABLE_VIDEOS.find(video => video.videoId === videoId);
			if (video) {
				setSelectedVideo(video);
			} else {
				handleError(serverError);
			}
		}
	}, []);
	return (
		<>
			{selectedVideo && (
				<div className='video-page-container'>
					<div className='video-mask'>
						<VideoVimeoComponent
							autoplay={selectedVideo.autoplay}
							videoId={selectedVideo.videoId}
							videoTitle={selectedVideo.videoTitle}
							hash={selectedVideo.hash}
						></VideoVimeoComponent>
					</div>
				</div>
			)}
		</>
	);
};

export default VideoPage;
